export enum BeneficiaryTypeEnum {
  LegalEntity = 1,
  Individual = 2,
}
